import {React,useEffect, createContext} from "react";
import PageMaster from "../../components/master/pagemaster";
import { HOME_PAGE_URL } from "../../services/common/endpoints";
// import QuicklinksComponent from "../../components/home/quicklinks";
import {RecordScreenEvent}  from '../../../src/analytics/RecordEvents'
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { setShowNotificationGreetingSection } from "../../reducer/actions";
import { setShowNotificationAndProfile } from "../../reducer/utilitySlice";

export const UserContext = createContext();

const HomeIndex = ({ navigation, route }) => {
  const dispatch = useDispatch();
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const userdata = useSelector((state) => state?.userdata?.value?.rnuserdetails);
  const {state} = useLocation();
  useEffect(()=>{
    try{
      RecordScreenEvent('home',logintype,userdata);
  }catch(e){}
  },[]);

  useEffect(() => {
    dispatch(setShowNotificationGreetingSection(true));
    dispatch(setShowNotificationAndProfile(false));
  }, [])


  return (
  <UserContext.Provider value={state?.isChildMsisdn}>
    <PageMaster
      urlKey="homeindex"
      apiurl={HOME_PAGE_URL.url}
      reqobj={HOME_PAGE_URL.data}
      headertitle="Home"
    />
  </UserContext.Provider>
  ); 
};

export default HomeIndex;
